/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Authentication API
 * This Authentification API for Kazaar
 * OpenAPI spec version: 1.1.11
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateRole201,
  CreateRole400,
  CreateRoleDto,
  DeleteRole404,
  GetRole200,
  GetRole404,
  ListPermissions200,
  ListRoles200,
  ListRolesParams,
  UpdateRole200,
  UpdateRole400,
  UpdateRole404,
  UpdateRoleDto
} from '../../schemas';

import { customFetch } from '../../../../../clients/customInstance';
import type { ErrorType } from '../../../../../clients/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Get all roles with pagination
 * @summary List Roles
 */
export type listRolesResponse200 = {
  data: ListRoles200
  status: 200
}

export type listRolesResponseSuccess = (listRolesResponse200) & {
  headers: Headers;
};
;

export type listRolesResponse = (listRolesResponseSuccess)

export const getListRolesUrl = (params: ListRolesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/roles?${stringifiedParams}` : `/auth/roles`
}

export const listRoles = async (params: ListRolesParams, options?: RequestInit): Promise<listRolesResponse> => {
  
  return customFetch<listRolesResponse>(getListRolesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getListRolesQueryKey = (params?: ListRolesParams,) => {
    return [
    `/auth/roles`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getListRolesQueryOptions = <TData = Awaited<ReturnType<typeof listRoles>>, TError = ErrorType<unknown>>(params: ListRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRolesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRoles>>> = ({ signal }) => listRoles(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRolesQueryResult = NonNullable<Awaited<ReturnType<typeof listRoles>>>
export type ListRolesQueryError = ErrorType<unknown>


export function useListRoles<TData = Awaited<ReturnType<typeof listRoles>>, TError = ErrorType<unknown>>(
 params: ListRolesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRoles>>,
          TError,
          Awaited<ReturnType<typeof listRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRoles<TData = Awaited<ReturnType<typeof listRoles>>, TError = ErrorType<unknown>>(
 params: ListRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRoles>>,
          TError,
          Awaited<ReturnType<typeof listRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRoles<TData = Awaited<ReturnType<typeof listRoles>>, TError = ErrorType<unknown>>(
 params: ListRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Roles
 */

export function useListRoles<TData = Awaited<ReturnType<typeof listRoles>>, TError = ErrorType<unknown>>(
 params: ListRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRolesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Create a new role with the provided data
 * @summary Create Role
 */
export type createRoleResponse201 = {
  data: CreateRole201
  status: 201
}

export type createRoleResponse400 = {
  data: CreateRole400
  status: 400
}

export type createRoleResponseSuccess = (createRoleResponse201) & {
  headers: Headers;
};
export type createRoleResponseError = (createRoleResponse400) & {
  headers: Headers;
};

export type createRoleResponse = (createRoleResponseSuccess | createRoleResponseError)

export const getCreateRoleUrl = () => {


  

  return `/auth/roles`
}

export const createRole = async (createRoleDto: CreateRoleDto, options?: RequestInit): Promise<createRoleResponse> => {
  
  return customFetch<createRoleResponse>(getCreateRoleUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createRoleDto,)
  }
);}
  



export const getCreateRoleMutationOptions = <TError = ErrorType<CreateRole400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRole>>, TError,{data: CreateRoleDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRole>>, TError,{data: CreateRoleDto}, TContext> => {

const mutationKey = ['createRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRole>>, {data: CreateRoleDto}> = (props) => {
          const {data} = props ?? {};

          return  createRole(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof createRole>>>
    export type CreateRoleMutationBody = CreateRoleDto
    export type CreateRoleMutationError = ErrorType<CreateRole400>

    /**
 * @summary Create Role
 */
export const useCreateRole = <TError = ErrorType<CreateRole400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRole>>, TError,{data: CreateRoleDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRole>>,
        TError,
        {data: CreateRoleDto},
        TContext
      > => {
      return useMutation(getCreateRoleMutationOptions(options), queryClient);
    }
    /**
 * Get all permissions
 * @summary List Permissions
 */
export type listPermissionsResponse200 = {
  data: ListPermissions200
  status: 200
}

export type listPermissionsResponseSuccess = (listPermissionsResponse200) & {
  headers: Headers;
};
;

export type listPermissionsResponse = (listPermissionsResponseSuccess)

export const getListPermissionsUrl = () => {


  

  return `/auth/roles/permissions`
}

export const listPermissions = async ( options?: RequestInit): Promise<listPermissionsResponse> => {
  
  return customFetch<listPermissionsResponse>(getListPermissionsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getListPermissionsQueryKey = () => {
    return [
    `/auth/roles/permissions`
    ] as const;
    }

    
export const getListPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof listPermissions>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPermissions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPermissionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPermissions>>> = ({ signal }) => listPermissions({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof listPermissions>>>
export type ListPermissionsQueryError = ErrorType<unknown>


export function useListPermissions<TData = Awaited<ReturnType<typeof listPermissions>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPermissions>>,
          TError,
          Awaited<ReturnType<typeof listPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPermissions<TData = Awaited<ReturnType<typeof listPermissions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPermissions>>,
          TError,
          Awaited<ReturnType<typeof listPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPermissions<TData = Awaited<ReturnType<typeof listPermissions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPermissions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Permissions
 */

export function useListPermissions<TData = Awaited<ReturnType<typeof listPermissions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPermissions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPermissionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Get a role by id
 * @summary Get Role
 */
export type getRoleResponse200 = {
  data: GetRole200
  status: 200
}

export type getRoleResponse404 = {
  data: GetRole404
  status: 404
}

export type getRoleResponseSuccess = (getRoleResponse200) & {
  headers: Headers;
};
export type getRoleResponseError = (getRoleResponse404) & {
  headers: Headers;
};

export type getRoleResponse = (getRoleResponseSuccess | getRoleResponseError)

export const getGetRoleUrl = (id: string,) => {


  

  return `/auth/roles/${id}`
}

export const getRole = async (id: string, options?: RequestInit): Promise<getRoleResponse> => {
  
  return customFetch<getRoleResponse>(getGetRoleUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetRoleQueryKey = (id: string,) => {
    return [
    `/auth/roles/${id}`
    ] as const;
    }

    
export const getGetRoleQueryOptions = <TData = Awaited<ReturnType<typeof getRole>>, TError = ErrorType<GetRole404>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoleQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRole>>> = ({ signal }) => getRole(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getRole>>>
export type GetRoleQueryError = ErrorType<GetRole404>


export function useGetRole<TData = Awaited<ReturnType<typeof getRole>>, TError = ErrorType<GetRole404>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRole>>,
          TError,
          Awaited<ReturnType<typeof getRole>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRole<TData = Awaited<ReturnType<typeof getRole>>, TError = ErrorType<GetRole404>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRole>>,
          TError,
          Awaited<ReturnType<typeof getRole>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRole<TData = Awaited<ReturnType<typeof getRole>>, TError = ErrorType<GetRole404>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Role
 */

export function useGetRole<TData = Awaited<ReturnType<typeof getRole>>, TError = ErrorType<GetRole404>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRoleQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Update an existing role with the provided data
 * @summary Update Role
 */
export type updateRoleResponse200 = {
  data: UpdateRole200
  status: 200
}

export type updateRoleResponse400 = {
  data: UpdateRole400
  status: 400
}

export type updateRoleResponse404 = {
  data: UpdateRole404
  status: 404
}

export type updateRoleResponseSuccess = (updateRoleResponse200) & {
  headers: Headers;
};
export type updateRoleResponseError = (updateRoleResponse400 | updateRoleResponse404) & {
  headers: Headers;
};

export type updateRoleResponse = (updateRoleResponseSuccess | updateRoleResponseError)

export const getUpdateRoleUrl = (id: string,) => {


  

  return `/auth/roles/${id}`
}

export const updateRole = async (id: string,
    updateRoleDto: UpdateRoleDto, options?: RequestInit): Promise<updateRoleResponse> => {
  
  return customFetch<updateRoleResponse>(getUpdateRoleUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateRoleDto,)
  }
);}
  



export const getUpdateRoleMutationOptions = <TError = ErrorType<UpdateRole400 | UpdateRole404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError,{id: string;data: UpdateRoleDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError,{id: string;data: UpdateRoleDto}, TContext> => {

const mutationKey = ['updateRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRole>>, {id: string;data: UpdateRoleDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateRole(id,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateRole>>>
    export type UpdateRoleMutationBody = UpdateRoleDto
    export type UpdateRoleMutationError = ErrorType<UpdateRole400 | UpdateRole404>

    /**
 * @summary Update Role
 */
export const useUpdateRole = <TError = ErrorType<UpdateRole400 | UpdateRole404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError,{id: string;data: UpdateRoleDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRole>>,
        TError,
        {id: string;data: UpdateRoleDto},
        TContext
      > => {
      return useMutation(getUpdateRoleMutationOptions(options), queryClient);
    }
    /**
 * Delete a role by id
 * @summary Delete Role
 */
export type deleteRoleResponse204 = {
  data: void
  status: 204
}

export type deleteRoleResponse404 = {
  data: DeleteRole404
  status: 404
}

export type deleteRoleResponseSuccess = (deleteRoleResponse204) & {
  headers: Headers;
};
export type deleteRoleResponseError = (deleteRoleResponse404) & {
  headers: Headers;
};

export type deleteRoleResponse = (deleteRoleResponseSuccess | deleteRoleResponseError)

export const getDeleteRoleUrl = (id: string,) => {


  

  return `/auth/roles/${id}`
}

export const deleteRole = async (id: string, options?: RequestInit): Promise<deleteRoleResponse> => {
  
  return customFetch<deleteRoleResponse>(getDeleteRoleUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getDeleteRoleMutationOptions = <TError = ErrorType<DeleteRole404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRole>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRole>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRole>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteRole(id,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRoleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRole>>>
    
    export type DeleteRoleMutationError = ErrorType<DeleteRole404>

    /**
 * @summary Delete Role
 */
export const useDeleteRole = <TError = ErrorType<DeleteRole404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRole>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRole>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteRoleMutationOptions(options), queryClient);
    }
    